'use client';

import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useSelectedItemIds } from '@/components/product-selection/hooks/useSelectedItemIds';

export const RxDisclaimer = () => {
  const { selectedRxCards } = useSelectedItemIds();

  return (
    <div className="cur-space-y-2">
      {selectedRxCards.length > 1 && (
        <Typography size="meta">
          Rx products are subject to consultation. If your dermatology provider
          cannot prescribe one due to any reason, it will be removed, and the
          cost of your subscription may be lower.
        </Typography>
      )}
      {selectedRxCards
        .filter((rxCard) => !!rxCard.claim?.disclaimer)
        .map((rxCard) => (
          <Typography key={rxCard.id} size="meta">
            {rxCard.claim?.disclaimer}
          </Typography>
        ))}
    </div>
  );
};
